import $ from 'jquery';

const SearchForm = {

	/**
	 * Search form element.
	 *
	 * @type {object}
	 */
	$el: {},

	/**
	 * Search form wrapper.
	 *
	 * @type {object}
	 */
	$wrap: {},

	/**
	 * Window.
	 *
	 * @type {object}
	 */
	$window: {},

	/**
	 * Search form toggle.
	 *
	 * @type {object}
	 */
	$toggle: {},

	/**
	 * Search timer.
	 *
	 * @type {number}
	 */
	timer: 0,

	/**
	 * Number of milliseconds after which the form should disappear.
	 *
	 * @type {number}
	 */
	timeout: 1000,

	/**
	 * Initialize.
	 *
	 * @returns {void}
	 */
	init() {
		this.$el     = $( '.c-nav__search' );
		this.$wrap   = $( '.c-nav__search__wrap', this.$el );
		this.$toggle = $( '.c-nav__main a[href*="/?s"]' );
		this.$window = $( window );

		// Remove this when search is rolled out to all users.
		this.$toggle.parent().addClass( 'c-nav__search-icon' );

		this.$toggle
			.on( 'mouseenter', () => this.show() )
			.on( 'mouseleave', () => this.hideDelayed() );

		this.$el
			.on( 'mouseenter', () => this.show() )
			.on( 'mouseleave', () => this.hideDelayed() );

		this.$toggle.parent().siblings().on( 'mouseenter', () => this.hide() );
	},

	/**
	 * Show form.
	 *
	 * @returns {void}
	 */
	show() {
		// don't do anything if this is the mobile menu, we just want to link through to the search page
		if ( $( '.c-nav__items__wrap' ).hasClass( 'is-expanded' ) ) {
			return false;
		}
 
		clearTimeout( this.timer );
		this.$el.addClass( 'is-active' );
		this.$toggle.addClass( 'is-active' );
		this.scrollIntoView();
	},

	/**
	 * Hide form.
	 *
	 * @returns {void}
	 */
	hide() {
		clearTimeout( this.timer );
		this.$el.removeClass( 'is-active' );
		this.$toggle.removeClass( 'is-active' );
	},

	/**
	 * Scroll form into view.
	 *
	 * @returns {void}
	 */
	scrollIntoView() {
		const elBottomOffset = this.$el.offset().top + this.$el.height() + this.$wrap.height();
		const scrollTop = this.$window.scrollTop();
		const viewportBottomOffset = scrollTop + window.innerHeight;
		const scrollMin = scrollTop + elBottomOffset - viewportBottomOffset;

		if ( scrollTop < scrollMin ) {
			$( 'html, body' ).animate({
					scrollTop: scrollMin
				},
				500
			);
		};
	},

	/**
	 * Hide form with delay.
	 *
	 * @returns {void}
	 */
	hideDelayed() {
		this.timer = setTimeout( () => {
			this.hide();
		}, this.timeout );
	}
};

export default SearchForm;
